// eslint-disable-next-line no-var
export var RelatedWikiForm = {
   initialize: function (form) {
      let wikiRelatedInputDiv = $('wikiRelatedInputDiv');

      $$('.wikiRelatedFormToggle').each(element => {
         element.addEvent('click', ev => {
            ev.stop();
            wikiRelatedInputDiv.toggleClass('hidden');
            when($('wikiRelatedHeaderLink'), link => {
               link.toggleClass('hidden');
            });
         });
      });

      form.addEvent('submit', ev => {
         ev.stop();
         let msgDiv = form.getElement('.statusError');

         new Request.AjaxIO('setRelatedWiki', {
            onSuccess: function (response) {
               msgDiv.set('text', response.message);
               if (response.error) {
                  form.getElement('input').blur();
                  msgDiv.show();
                  msgDiv.setStyle('opacity', 1);
                  setTimeout(() => msgDiv.hide(), 3000);
               } else {
                  window.location.reload();
               }
            },
         }).send(form.toQueryString().parseQueryString());
      });
   },
};
